import {h, Fragment} from "preact"
import { useAppStateSelector } from "@nosto/preact"
import { translatedText } from "./utils/translatedText";

export default function NoResults() {
    const query = useAppStateSelector(state => state?.response?.query)

    return (
        <div class="ns-my-5 ns-mx-0">
            <div class="ns-text-align-center ns-font-4">{translatedText("suggestions")} '{query}'</div>
            <div class="ns-my-5 nosto-rec-container">
                <div class="nosto_element" id="noresults-nosto-1"></div>
            </div>
        </div>
    )
}
